import { render, staticRenderFns } from "./updatePsw.vue?vue&type=template&id=5b6737d8&scoped=true"
import script from "./updatePsw.vue?vue&type=script&lang=js"
export * from "./updatePsw.vue?vue&type=script&lang=js"
import style0 from "./updatePsw.vue?vue&type=style&index=0&id=5b6737d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6737d8",
  null
  
)

export default component.exports